SupportBaseTicketModel = require('./base_ticket_model')

class SupportEmailFormModel extends SupportBaseTicketModel

  initialize: ->
    SupportBaseTicketModel::initialize.apply(this, arguments)
    @getDefaultEmailForm()
    @setEmailForm()
    @initializeEmailFormObjectsCount()

  setEmailForm: ()->
    contentModelFlexibleStepThree = Groupon.Support.ContentModel.flexibleStepThree

    unless contentModelFlexibleStepThree?
      @emailForm = $.extend(true, {}, @defaultEmailForm)
      @isFlexibleStepThree = false
    else
      @emailForm = $.extend(true, {}, contentModelFlexibleStepThree)
      @addRequiredItemsToFlexibleEmailForm()
      @isFlexibleStepThree = true

  initializeEmailFormObjectsCount: ()->
    @emailFormObjectsCount =
      phone_number: 0
      email_address: 0
      user_name: 0
      number: 0
      text_field_paragraph: 0
      text_field_line: 0
      attachment: 0
      calendar_date: 0
      calendar_with_hour_slot: 0
      dropdown: 0
      checkbox: 0
      text_paragraph: 0

  addRequiredItemsToFlexibleEmailForm: ->
    phoneNumber = 'phone_number'
    emailAddress = 'email_address'
    userName = 'user_name'

    if window.isUS()
      return @addRequiredItemsToFlexibleEmailFormForUS()
    else if @isMethodOfContactByPhone()
      @addDefaultFormObjectsToEmailForm()
    else
      unless @emailForm.objects?.length > 0
        @emailForm.objects = []
      @addObjectToEmailForm @checkConditionsToAddPhoneNumbers(phoneNumber), phoneNumber
      @addObjectToEmailForm not(currentUser?.email?) and not(@isObjectTypeAlreadyPresent(emailAddress)), emailAddress
      @addObjectToEmailForm @checkIfUserNameIsEmpty(), userName

  checkIfUserNameIsEmpty: ->
    _.isEmpty(currentUser?.firstName) and _.isEmpty(currentUser?.lastName)

  checkConditionsToAddPhoneNumbers:(phoneNumber)->
    not(@isObjectTypeAlreadyPresent(phoneNumber)) and not window.priorityViewsEnabled()

  isObjectTypeAlreadyPresent:(flexStepThreeObjType) ->
    for flexibleStepThreeObj in @emailForm.objects
      if flexibleStepThreeObj.type is flexStepThreeObjType then return true
    false

  addObjectToEmailForm: (criteriaToAdd, objectToBeAdded) ->
    if criteriaToAdd then @emailForm.objects.splice(0, 0, @getRequiredItem(objectToBeAdded))

  addDefaultFormObjectsToEmailForm: () ->
    @emailForm.objects = $.extend(true, [], @defaultEmailForm.objects)

  getEmailFormInputObjects: ()->
    if @emailForm.objects?.length > 0 then @emailForm.objects else @defaultEmailForm.objects

  isMethodOfContactByPhone:()->
    @emailForm.method_of_contact == 'phone'

  isMethodOfContactByPhoneWithEmail:()->
    @emailForm.method_of_contact == 'phone_with_email'

  numberOfRedemptionLocationsAvailable: ->
    if Groupon.Support.currentOrder?.dealOption?.redemptionLocations?
      return Groupon.Support.currentOrder.dealOption.redemptionLocations.length
    else
      return 0

  isFTRDropdownCombinationSlected : () ->
    FTRDropDownCombination = [
      {
        categoryId: "a_problem_with_the_business",
        subCategoryId: "the_business_is_not_returning_my_calls_or_emails"
      },
      {
        categoryId: "an_expired_groupon",
        subCategoryId: "the_business_is_not_returning_my_calls_or_emails"
      }
    ]
    @checkIfAnyDropdownCombinationMatches(FTRDropDownCombination)

  checkIfAnyDropdownCombinationMatches:(dropdownCombo) ->
    _.some(dropdownCombo, (dropdown) =>
      { categoryId, subCategoryId } = dropdown
      ( @parentCategoryId.indexOf(categoryId) > -1 ) and ( @reasonId.indexOf(subCategoryId) > -1 )
    )

  getDefaultEmailForm : () ->
    return @defaultEmailForm if @defaultEmailForm?
    if window.isUS()
      @defaultEmailForm = @getDefaultEmailFormForUS()
    else
      @defaultEmailForm = @getDefaultEmailFormForEMEA()

  getDefaultEmailFormForUS : () ->
    objects = []
    objects.push { type: "user_identification", required: "true" } if @canShowUserIdentificatioView()
    objects.push { type: "merchant_location",   required: "true" } if @canShowMerchantLocationInfoView()
    objects.push { type: "user_contact_info",   required: "true" } if @canShowUserContactInfoView()
    objects.push { type: "description", required: "true" , append: true }
    dynamicEmailForm =
      method_of_contact: "email",
      objects: objects

  getDefaultEmailFormForEMEA: ->
    dynamicEmailForm =
      method_of_contact: "email",
      objects: [
        {
          type: "user_name",
          label: I18n.translate('js.modules.support.userlabel'),
          required: "true",
          additional_attributes: {
            maximum_number_of_characters_or_digits: ""
          }
        },
        {
          type: "email_address",
          label: I18n.translate('js.modules.support.emaillabel'),
          required: "true"
        },
        {
          type: "phone_number",
          label: I18n.translate('js.modules.support.user_phone_number'),
          required: "false"
        },
        {
          type: "text_field_paragraph",
          label: I18n.translate('js.modules.support.whatson'),
          required: "true",
          additional_attributes: {
            maximum_number_of_characters_or_digits: "2000"
          }
        },
        {
          type: "attachment",
          label: I18n.translate('js.modules.support.attach_file'),
          required: "false"
        }
      ]
    unless @isFileUploadEnabled()
      dynamicEmailForm.objects = _.reject dynamicEmailForm.objects, (object)->
        object.type is 'attachment'
    unless @canShowUserIdentificatioView()
      dynamicEmailForm.objects = _.reject dynamicEmailForm.objects, (object)->
        object.type is 'email_address'
    unless @checkIfUserNameIsEmpty()
      dynamicEmailForm.objects = _.reject dynamicEmailForm.objects, (object)->
        object.type is 'user_name'
    dynamicEmailForm

  isFileUploadEnabled: ->
    window.evaluate(experiments?.fileUpload)

  getRequiredItem: (item) ->
    defaultEmailFormObjects = @getDefaultEmailForm().objects
    requiredItem = {}
    for obj in defaultEmailFormObjects
      if obj.type is item then requiredItem = obj
    requiredItem

  canShowUserIdentificatioView: ->
    !isUserLogged() or !currentUser.email?

  canShowMerchantLocationInfoView: ->
    Groupon.Support.FeatureFlagModel.isShowMerchantInfoFieldsEnabled() and (@isFTRDropdownCombinationSlected() && @numberOfRedemptionLocationsAvailable() != 1)

  canShowUserContactInfoView: ->
    Groupon.Support.FeatureFlagModel.isShowUserContactInfoFieldsEnabled() and @isFTRDropdownCombinationSlected()

  addRequiredItemsToFlexibleEmailFormForUS: ->
    if @emailForm?.objects?.length > 0
      defaultEmailFormObjects = @getDefaultEmailForm().objects
      objectsToBeAppended =  []
      objectsToBePrepended = []
      _.each(defaultEmailFormObjects, (obj) ->
        if obj.append
          objectsToBeAppended.push(obj)
        else
          objectsToBePrepended.push(obj)
      )
      @addRequiredItemsToFlexibleStepThreeForCMSUS(objectsToBePrepended)
      objects = $.merge( $.merge( objectsToBePrepended, @emailForm.objects ), objectsToBeAppended )
      @emailForm.objects = objects

  addRequiredItemsToFlexibleStepThreeForCMSUS: (objectsToBePrepended = []) ->
    if window.evaluate(experiments?.shouldDisplayCMSContentForUS)
      userContactInfoDropDownCombination = [
        {
          categoryId: "a_problem_with_the_business",
          subCategoryId: "the_business_won_t_accept_my_groupon"
        }
      ]
      phoneNumberDropDownCombination = [
        {
          categoryId: "a_problem_with_the_business",
          subCategoryId: "the_business_is_closed"
        }
      ]
      textFieldDropDownCombination = [
        {
          categoryId: "a_problem_with_the_business",
          subCategoryId: "the_business_won_t_accept_my_groupon"
        }
      ]

      if @checkIfAnyDropdownCombinationMatches(userContactInfoDropDownCombination)
        objectsToBePrepended.push({
         type: "user_contact_info",
         required: "true"
        })

      if @checkIfAnyDropdownCombinationMatches(phoneNumberDropDownCombination)
        objectsToBePrepended.push({
          type: "phone_number",
          label: I18n.translate('js.modules.support.phone_number_called'),
          required: "false"
        })

      if @checkIfAnyDropdownCombinationMatches(textFieldDropDownCombination)
        objectsToBePrepended.push({
          type: "text_field_line",
          label: I18n.translate('js.modules.support.location_visited'),
          required: "true"
        })

      objectsToBePrepended

module.exports = SupportEmailFormModel
